import { useContext } from "react";
import { globalContext } from "../../global/Store";
import config from "../../config/Config.json";
import { GetMockDevelopmentRead } from "../../mock/development/DevelopmentRead";
import { GetMockDevelopmentList } from "../../mock/development/DevelopmentList";

export const useDevelopmentDataRepo = () => {
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);

  const GetDevelopment = (id: number) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockDevelopmentRead());
      } else {
        globalFunctions
          .CallPortalApi("Development/Read", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const GetDevelopmentList = () => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockDevelopmentList());
      } else {
        globalFunctions
          .CallPortalApi("Development/List", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  return { GetDevelopment, GetDevelopmentList };
};
